import { TCacheOptions } from './types';

export const DEFAULT_MAX_AGE = 10 * 60 * 1000;
export const DEFAULT_CACHE_BYPASS = false;
export const DEFAULT_CACHE_OPTIONS: TCacheOptions<unknown> = {
  maxAge: DEFAULT_MAX_AGE,
  stale: true,
};
